import StaticReportsSnowflakeReducer, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const staticReportsSnowflakeActions = { ...actions, ...thunkActions };
export * as StaticReportsTypes from './types';
export default StaticReportsSnowflakeReducer;
